import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import {ExpensesCategory} from './expenses-category.entity';
import {ExpensesCategoryDTO} from './dto/expenses-category.dto';
import {ExpensesCategoryService} from './expenses-category.service';
import { ExpensesCategoryResponse, AllExpensesCategoryResponse } from '@gtpl/shared-models/hrms';
import { ExpensesCategoryRequest } from './dto/expenses-category.request';
@ApiTags('expenses-category')
@Controller('expenses-category')
export class ExpensesCategoryController {





    constructor(
        private expensesCategoryService: ExpensesCategoryService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createExpensesCategory')
    async createExpensesCategory(@Body() expensesCategoryDto:ExpensesCategoryDTO,isUpdate:boolean=false): Promise<ExpensesCategoryResponse> {
    try {
        return await this.expensesCategoryService.createExpensesCategory(expensesCategoryDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(ExpensesCategoryResponse, error);
      }
    }
    @Post('/updateExpensesCategory')
  async updateExpensesCategory(@Body() expensesCategoryDto: ExpensesCategoryDTO,@Req() request:Request): Promise<ExpensesCategoryResponse> {
    try {
      console.log('update Expenses Category');expensesCategoryDto
      console.log(request);
      return await this.expensesCategoryService.createExpensesCategory(expensesCategoryDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ExpensesCategoryResponse, error);
    }
  }
  @Post('/getAllExpensesCategories')
  // @UseGuards(AuthGuard('jwt'))
  async getAllExpensesCategories(): Promise<AllExpensesCategoryResponse> {
    try {
      return await this.expensesCategoryService.getAllExpensesCategories();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllExpensesCategoryResponse, error);
    }
  }
  @Post('/activateOrDeactivateExpensesCategory')
  async activateOrDeactivateExpensesCategory(@Body() expensesCategoryReq: ExpensesCategoryRequest): Promise<ExpensesCategoryResponse> {
      try {
          return await this.expensesCategoryService.activateOrDeactivateExpensesCategory(expensesCategoryReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(ExpensesCategoryResponse, err);
      }
  }
  @Post('/getAllActiveExpensesCategories')
  async getAllActiveExpensesCategories(@Req() request: Request): Promise<AllExpensesCategoryResponse> {
      try {
          return await this.expensesCategoryService.getAllActiveExpensesCategories();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllExpensesCategoryResponse, error)
      }
  }
  @Post('/getExpensesCategoryById')
  async getExpensesCategoryById(@Body() expensesCategoryReq: ExpensesCategoryRequest): Promise<ExpensesCategoryResponse> {
      try {
          return await this.expensesCategoryService.getActiveExpensesCategoryById(expensesCategoryReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(ExpensesCategoryResponse, err);
      }
  }
}
